import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/QuestionMockExams.css";

const QuestionMockExams = () => {
  const navigate = useNavigate();

  return (
    <div className="mock-exams-container">
      <h1 className="mock-exams-header">Mock exams</h1>

      <p className="mock-exams-description">
        Mock exams are designed to recreate what you will experience on the day
        of the exam as accurately as possible. As exams increasingly move online
        we've also recreated the kind of interface you'll use. The questions are
        hand picked by our editors to reflect the range and weighting of the
        syllabus. The questions are completely separate from the main question
        bank and the mock exam score will not affect your overall performance
        data. If you are unable to complete the mock exam in one sitting you
        have the option of saving your progress and completing the exam at a
        later date.
      </p>

      <div className="mock-exams-list">
        {/* 
        <div className="mock-exam-card">
          <h2 className="mock-exam-title">Applied Knowledge Test - Mock Exam A</h2>
          <p className="mock-exam-details">
            This mock exam consists of 200 questions over 190 minutes
          </p>
          <button 
            className="mock-exam-button"
            onClick={() => navigate("/mock-exam-instruction")}
          >
            Start this mock exam
          </button>
        </div>
        */}

        <div className="mock-exam-card">
          <h2 className="mock-exam-title">
            Applied Knowledge Test - Mock Exam 
          </h2>
          <p className="mock-exam-details">
            This mock exam consists of 200 questions over 190 minutes
          </p>
          <button
            className="mock-exam-button"
            onClick={() => navigate("/mock-exam-instruction")}
          >
            Start this mock exam
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionMockExams;
